import {
  Grid,
  Typography,
  WithStyles,
  withStyles,
  CardActions,
} from "@material-ui/core";
import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { DialogLargeStyle } from "../styles/DialogLargeStyle";
import CloseIcon from "@material-ui/icons/Close";

interface DialogFooterProps extends WithStyles<typeof DialogLargeStyle> {
  htmlElements: ReactNode;
  classes: any;
  leftHTMLElement: any;
}

class DialogFooter extends Component<DialogFooterProps> {
  constructor(props: DialogFooterProps) {
    super(props);
  }
  render() {
    const { htmlElements, classes, leftHTMLElement } = this.props;

    return (
      <>
        <CardActions classes={{ root: classes.dialog_footerFixed }}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <div className={classes.dialog_btnGroup}>{htmlElements}</div>
            </Grid>

            <Grid item xs={6}>{leftHTMLElement}</Grid>
          </Grid>
        </CardActions>
      </>
    );
  }
}

// @ts-ignore
export default connect()(withStyles(DialogLargeStyle)(DialogFooter));
